(() => {
  const lifecycle = window.StepaheadUiLifecycle;
  if (!lifecycle?.register) return;

  lifecycle.register({
    name: 'home-marquee',
    selector: '[data-home-marquee]',
    mount(root) {
      const rows = [...root.querySelectorAll('[data-home-marquee-row]')];
      const motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      let inView = !('IntersectionObserver' in window);

      const measure = () => {
        rows.forEach((row) => {
          const segment = row.querySelector('[data-home-marquee-segment]');
          const track = row.querySelector('[data-home-marquee-track]');
          const speed = Number(row.dataset.speed);
          const phase = Number(row.dataset.phase);
          const width = segment?.getBoundingClientRect().width ?? 0;
          if (!track || !width || !speed || !Number.isFinite(phase)) return;

          const duration = width / speed;
          track.style.setProperty('--home-marquee-duration', `${duration}s`);
          track.style.setProperty('--home-marquee-phase', `${duration * phase * -1}s`);
        });
      };

      const syncPlayback = () => {
        root.dataset.inView = String(inView);
        root.dataset.paused = String(document.hidden || !inView || Boolean(motionQuery?.matches));
      };

      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
      resizeObserver?.observe(root);

      const intersectionObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver(([entry]) => {
            inView = Boolean(entry?.isIntersecting);
            syncPlayback();
          }, { threshold: 0.01 })
        : null;
      intersectionObserver?.observe(root);

      const onVisibilityChange = () => syncPlayback();
      const onMotionChange = () => syncPlayback();
      document.addEventListener('visibilitychange', onVisibilityChange);
      motionQuery?.addEventListener('change', onMotionChange);
      const frame = requestAnimationFrame(measure);
      syncPlayback();

      return () => {
        cancelAnimationFrame(frame);
        resizeObserver?.disconnect();
        intersectionObserver?.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        motionQuery?.removeEventListener('change', onMotionChange);
      };
    },
  });
})();
